// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tile__FeatureTile-module--ytcTa {
    justify-content: space-between;
    gap: var(--space-lg);
    padding: var(--space-md);
    border: none;
    border-radius: var(--home-radius-2xl);
    min-height: 180px;
    transition: transform 0.2s ease;
}

.tile__FeatureTile-module--ytcTa:hover {
    transform: translateY(-4px);
}

@media (prefers-reduced-motion: reduce) {
    .tile__FeatureTile-module--ytcTa {
        transition-duration: 0.01s;
    }
}

.tileHero__FeatureTile-module--HDA_f {
    grid-row: span 2;
}

.label__FeatureTile-module--oq6i_ {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
}

.labelHero__FeatureTile-module--AtbDw {
    font-size: clamp(28px, 3.4vw, 40px);
    font-weight: 800;
    letter-spacing: -0.02em;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/FeatureTile.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,wBAAwB;IACxB,YAAY;IACZ,qCAAqC;IACrC,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".tile {\n    justify-content: space-between;\n    gap: var(--space-lg);\n    padding: var(--space-md);\n    border: none;\n    border-radius: var(--home-radius-2xl);\n    min-height: 180px;\n    transition: transform 0.2s ease;\n}\n\n.tile:hover {\n    transform: translateY(-4px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .tile {\n        transition-duration: 0.01s;\n    }\n}\n\n.tileHero {\n    grid-row: span 2;\n}\n\n.label {\n    font-size: 22px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n}\n\n.labelHero {\n    font-size: clamp(28px, 3.4vw, 40px);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `tile__FeatureTile-module--ytcTa`,
	"tileHero": `tileHero__FeatureTile-module--HDA_f`,
	"label": `label__FeatureTile-module--oq6i_`,
	"labelHero": `labelHero__FeatureTile-module--AtbDw`
};
export default ___CSS_LOADER_EXPORT___;
